import React, { useState } from 'react';
import { useFilesConfig } from '../data/filesconfig-hooks';
import StringEditor from "../../../shared/editors/StringEditor";
import DropDownEditor from "../../../shared/editors/DropDownEditor";
import TextAreaEditor from "../../../shared/editors/TextAreaEditor";
import Label from "../../../shared/editors/Label";
import FormErrors from "../../../shared/controls/FormErrors";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

function FileDetail(props) {

    const { filesConfig, setDetailDialogVisible, updateFileDetail, updateFileTypeDetail } = useFilesConfig();

    const [errors, setErrors] = useState([]);

    const cancel = () => {
        setDetailDialogVisible(false, false);
    };

    const save = () => {

        var newErrors = [];

        if (filesConfig.EditingDetail.Name == null) {
            newErrors.push("[![Please enter a name]!]");
        }

        if (filesConfig.EditingDetail.FileType == null) {
            newErrors.push("[![Please enter a type]!]");
        }

        setErrors(newErrors);

        if (newErrors.length > 0) {
            return;
        }

        setDetailDialogVisible(false, true);
    };

    const updateState = (e) => {

        // Update the global state
        if(e.props.id == 'FileType') {
            var label = e.props.sortedOptions.find(o => o.Value == e.value).Label;
            updateFileTypeDetail(filesConfig.DetailDialogID, e.value, label)
        }
        else{
            updateFileDetail(filesConfig.DetailDialogID, e.props.id, e.value)
        }
    }

    const fileTypes = filesConfig.FileTypes;

    return (
        <Dialog title={"File Details"} onClose={cancel} width={650}>

            <FormErrors formErrors={errors} />

            <table className="form-container">
                <tbody>
                    <tr>
                        <Label Label="[![Name]!]" InfoToolTip="[![The name of the file]!]"></Label>
                        <StringEditor value={filesConfig.EditingDetail.Name} onChange={updateState} id="Name"></StringEditor>
                    </tr>
                    <tr>
                        <Label Label="[![Caption]!]" InfoToolTip="[![The caption for the file]!]"></Label>
                        <StringEditor value={filesConfig.EditingDetail.Caption} onChange={updateState} id="Caption"></StringEditor>
                    </tr>
                    <tr>
                        <Label Label="[![Author]!]" InfoToolTip="[![The author or credit for the file]!]"></Label>
                        <StringEditor value={filesConfig.EditingDetail.Author} onChange={updateState} id="Author"></StringEditor>
                    </tr>
                    <tr>
                        <Label Label="[![Type]!]" InfoToolTip="[![The type of file]!]"></Label>
                        <DropDownEditor sortedOptions={fileTypes} value={filesConfig.EditingDetail.FileType} onChange={updateState} id="FileType"></DropDownEditor>
                    </tr>
                    <tr>
                        <Label Label="[![Description]!]" InfoToolTip="[![A longer description describing the contents of the file]!]"></Label>
                        <TextAreaEditor value={filesConfig.EditingDetail.Description} onChange={updateState} id="Description" rows={5}></TextAreaEditor>
                    </tr>
                </tbody>
            </table>

            <DialogActionsBar>
                <button
                    className="button k-button"
                    onClick={cancel}
                >
                    [![Cancel]!]
                </button>
                <button
                    className="button button-primary k-button"
                    onClick={save}
                >
                    [![Update]!]
                </button>
            </DialogActionsBar>
        </Dialog>
    );
}

export default FileDetail;